import jwtDecode from 'jwt-decode'
import moment from 'moment'

/**
 * Set expiration access token date.
 *
 * @param {string} accessToken - Bearer token.
 */
export const setExpirationAccessTokenDate = (accessToken) => {
  let tokenPayloadDecode = {}
  let tokenIsValid = false
  try {
    tokenPayloadDecode = jwtDecode(accessToken)
    tokenIsValid = true
  } catch (error) {
    console.log('Access token decode error: ', error.message)
  }

  if (tokenIsValid) {
    const { iat, exp } = tokenPayloadDecode
    const issuedAt = moment.unix(iat)
    const expirationTime = moment.unix(exp)

    const timer = expirationTime.diff(issuedAt, 'seconds')
    const expirationDate = moment().unix() + timer

    localStorage.setItem('expirationAccessTokenDate', `${expirationDate}`)
  }
}
